import { RouteObject } from "react-router-dom";
import { ChangePasswordPage, ExternalSystemsPage, ProfilePage, SignOutHandlerPage, VerificationPage } from "../pages";
import { UsersPage, UserActionsPage } from "../pages/Administration";

const adminRoutes: RouteObject[] = [
    {
        path: '/',
        element: <ExternalSystemsPage />
    },
    {
        path: 'profile/:profileId',
        element: <ProfilePage />
    },
    {
        path: 'administration/users',
        element: <UsersPage />
    },
    {
        path: 'administration/user-event-log',
        element: <UserActionsPage />
    },
    {
        path: 'es/sign-out',
        element: <SignOutHandlerPage />
    },
    {
        path: 'change-password',
        element: <ChangePasswordPage />
    },
    {
        path: 'profile',
        element: <ProfilePage />
    },
    {
        path: 'profile/verification',
        element: <VerificationPage  />
    },
]

export default adminRoutes;